import React from 'react'; 
import PageHeading from './PageHeading';
import PageText from './PageText';
import PageSmallText from './PageSmallText';
import PageQuote from './PageQuote';
import PageTextColumns from './PageTextColumns';
import PageGallery from './PageGallery';
import PageInsetGallery from './PageInsetGallery';
import PageSideGallery from './PageSideGallery';
import PageTeam from './PageTeam';
import PageInformation from './PageInformation';
import PageSustainability from './PageSustainability';
import PageLocation from './PageLocation';
import PageGrid from './PageGrid';
import PageImageText from './PageImageText';
import PageTables from './PageTables';
import PageImage from './PageImage';
import PageSplash from './PageSplash';
import PageContact from './PageContact';

import WithConsumer from '../../context/WithConsumer';


const PageBlock = ({index,context}) => {
 	
 	if (context.posts) {
	 	
    	const posts 		= () => context.posts;
		const post 			= posts()[0];
		const block 		= post.block[index]; 
		    
		let content = '';
		
		if (block.type == 'heading') {
		
		    content = <PageHeading block={block}></PageHeading>
		
		} else if (block.type == 'text') {
			
			content = <PageText block={block}></PageText>
			
		} else if (block.type == 'small_text') {
			
			content = <PageSmallText block={block}></PageSmallText>
			
		} else if (block.type == 'quote') {
			
			content = <PageQuote block={block}></PageQuote>
			
		} else if (block.type == 'text_columns') {
			
			content = <PageTextColumns block={block}></PageTextColumns>
			
		} else if (block.type == 'splash') {
			
			content = <PageSplash block={block}></PageSplash>
			
		} else if (block.type == 'gallery') {
			
			content = <PageGallery block={block}></PageGallery>
			
		} else if (block.type == 'inset_gallery') {
			
			content = <PageInsetGallery block={block}></PageInsetGallery>
			
		} else if (block.type == 'side_by_side_gallery') {
			
			content = <PageSideGallery block={block}></PageSideGallery>
			
		} else if (block.type == 'team') {
			
			content = <PageTeam block={block}></PageTeam>
			
		} else if (block.type == 'information') {
			
			content = <PageInformation block={block}></PageInformation>
			
		} else if (block.type == 'sustainability') {
			
			content = <PageSustainability block={block}></PageSustainability>
			
		} else if (block.type == 'location') {
			
			content = <PageLocation block={block}></PageLocation>
			
		} else if (block.type == 'grid') {
			
			content = <PageGrid block={block}></PageGrid>
			
		}
    
		return content;
		
    } else {
	    
	    return null;
	    
    }

    

};
export default WithConsumer(PageBlock);